import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';
import Swal from 'sweetalert2';

const ModalPermisoEspecial = ({ open, onClose, onSuccess, nombrePermiso }) => {
    const [usuario, setUsuario] = useState('');
    const [clave, setClave] = useState('');
    const [loading, setLoading] = useState(false);

    const handleValidarPermiso = async () => {
        if (!usuario || !clave) {
            Swal.fire('Campos requeridos', 'Debe ingresar usuario y contraseña', 'warning');
            return;
        }

        try {
            setLoading(true);
            const server = process.env.REACT_APP_API_ROUTE;

            const response = await fetch(`${server}/MgUsuarios/LoginPermisosEspeciales/${usuario}/${clave}`);
            const data = await response.json();

            const permisos = data?.$values || [];

            const tienePermiso = permisos.some(p => p.permiso?.trim() === nombrePermiso.trim());

            if (tienePermiso) {
                Swal.fire('Autorizado', 'Permiso concedido', 'success');
                onSuccess(true);
                onClose();
            } else {
                Swal.fire('Permiso denegado', 'No tiene el permiso requerido', 'error');
                onSuccess(false);
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudo validar el permiso', 'error');
            console.error('Error validando permiso:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Validar Permiso Especial</DialogTitle>
            <DialogContent>
                <TextField
                    label="Usuario"
                    value={usuario}
                    onChange={(e) => setUsuario(e.target.value)}
                    fullWidth
                    margin="dense"
                />
                <TextField
                    label="Contraseña"
                    type="password"
                    value={clave}
                    onChange={(e) => setClave(e.target.value)}
                    fullWidth
                    margin="dense"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleValidarPermiso} disabled={loading} variant="contained" color="primary">
                    Validar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalPermisoEspecial;
